// UI-1 polish: hand-drawn 16px stroke icon set. No icon dependency (ARC-2 allowlist);
// theme-aware via currentColor. Keep paths minimal — they ship in the core bundle.

export type IconName =
  | "select"
  | "line"
  | "rect"
  | "circle"
  | "arc"
  | "freehand"
  | "text"
  | "label"
  | "dimension"
  | "grid"
  | "tape"
  | "calibrate"
  | "cloud"
  | "highlighter"
  | "image"
  | "crop"
  | "menu"
  | "undo"
  | "redo"
  | "fit"
  | "chevron-down"
  | "caret-right"
  | "close"
  | "plus"
  | "file"
  | "sample"
  | "zoom"
  | "group"
  | "pipe"
  | "wall";

const PATHS: Record<IconName, string> = {
  select: "M4.5 2.5 L12 9 L8.6 9.4 L10.4 13.3 L8.4 14.2 L6.6 10.3 L4.5 12.8 Z",
  line: "M3 13 L13 3 M3.7 13.7 a1 1 0 1 0 -1.4 -1.4 a1 1 0 0 0 1.4 1.4 M13.7 3.7 a1 1 0 1 0 -1.4 -1.4 a1 1 0 0 0 1.4 1.4",
  rect: "M2.5 4.5 h11 v7 h-11 Z",
  circle: "M13 8 A5 5 0 1 1 3 8 A5 5 0 1 1 13 8",
  arc: "M2.5 12.5 A8.5 8.5 0 0 1 13.5 12.5 M3.2 13.2 a1 1 0 1 0 -1.4 -1.4 a1 1 0 0 0 1.4 1.4 M14.2 13.2 a1 1 0 1 0 -1.4 -1.4 a1 1 0 0 0 1.4 1.4",
  freehand: "M2.5 11.5 C4.5 6 6 12.5 8.5 8.5 C10 6 11.5 5.5 13.5 4.5",
  text: "M3.5 5 V3.5 h9 V5 M8 3.5 V12.5 M6 12.5 h4",
  label: "M3 13 L8 8 H13.5 M3 13 l2.2 -0.5 M3 13 l0.5 -2.2",
  dimension: "M2.5 11.5 V6 M13.5 11.5 V6 M2.5 9 H13.5 M2.5 9 l2 -1.2 M2.5 9 l2 1.2 M13.5 9 l-2 -1.2 M13.5 9 l-2 1.2",
  grid: "M5.5 2.5 V13.5 M10.5 2.5 V13.5 M2.5 5.5 H13.5 M2.5 10.5 H13.5",
  tape: "M10.5 6.5 A3.5 3.5 0 1 0 7 10 M7 10 H13.5 M11 10 V8.5",
  calibrate: "M2.5 10.8 L10.8 2.5 L13.5 5.2 L5.2 13.5 Z M5.8 7.8 l1.4 1.4 M8.3 5.3 l1.4 1.4",
  cloud: "M5.5 12.5 h6.5 a2.5 2.5 0 0 0 .5 -4.9 a4 4 0 0 0 -7.8 -1 A3 3 0 0 0 5.5 12.5 Z",
  highlighter: "M3 13.5 h2.8 l7 -7 L10 3.7 l-7 7 Z M8.8 4.9 l2.8 2.8 M3 13.5 l-1 1",
  image: "M2.5 3.5 h11 v9 h-11 Z M2.5 10.5 l3 -3 l2.5 2.5 l2 -2 l3 3 M10.3 6 a0.9 0.9 0 1 0 0.001 0",
  crop: "M5 2.5 V11 h8.5 M2.5 5 H11 V13.5",
  menu: "M3 4.5 h10 M3 8 h10 M3 11.5 h10",
  undo: "M4 6.5 H10 a3.5 3.5 0 0 1 0 7 H7.5 M4 6.5 l3 -3 M4 6.5 l3 3",
  redo: "M12 6.5 H6 a3.5 3.5 0 0 0 0 7 h2.5 M12 6.5 l-3 -3 M12 6.5 l-3 3",
  fit: "M6 2.5 H2.5 V6 M10 2.5 H13.5 V6 M6 13.5 H2.5 V10 M10 13.5 H13.5 V10 M6.5 6.5 h3 v3 h-3 Z",
  "chevron-down": "M4 6 l4 4 l4 -4",
  "caret-right": "M6 4 l4 4 l-4 4",
  close: "M4 4 l8 8 M12 4 l-8 8",
  plus: "M8 3.5 V12.5 M3.5 8 H12.5",
  file: "M4 2.5 h5 l3 3 V13.5 H4 Z M9 2.5 V5.5 h3",
  sample: "M2.5 2.5 h11 v11 h-11 Z M2.5 8.5 h5.5 M8 8.5 V13.5 M8 2.5 V5.5",
  zoom: "M11.5 7 A4.5 4.5 0 1 1 2.5 7 A4.5 4.5 0 1 1 11.5 7 M10.3 10.3 L14 14",
  group: "M2.5 5.5 h8 v8 h-8 Z M5.5 5.5 V2.5 h8 v8 h-3",
  // 3.16.2: a pipe bend with a flange on each end (the straight pipe before it read as a box with lines)
  pipe: "M2 1.8 V8.2 M2 3.2 H7.5 A5.3 5.3 0 0 1 12.8 8.5 V14 M2 6.8 H7.5 A1.7 1.7 0 0 1 9.2 8.5 V14 M7.8 14 H14.2",
  // 3.20.0: a wall corner with its hatch (two faces, a mitred corner, three hatch strokes)
  wall: "M1.5 3 H13.5 V14.5 H9 V7.5 H1.5 Z M3 7.5 L7.5 3 M7 7.5 L11.5 3 M9 11 L13.5 6.5 M9 14.5 L13.5 10"
};

export function Icon({ name, size = 16 }: { name: IconName; size?: number }) {
  return (
    <svg
      class="icon"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
